import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CdcLojaService } from '../../services/cdc-loja.service';
import { EcommerceEtapas } from '../ecommerce-etapas';
export class EnderecosClienteComponent {
    constructor(fb, cdcLojaService) {
        this.fb = fb;
        this.cdcLojaService = cdcLojaService;
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
        this.showLoader = false;
    }
    ngOnInit() {
        this.initForms();
        this.proposta = EcommerceEtapas.proposta;
        this.hasEnderecoComercial = !this.isAposentadoOrAutonomo() && !this.isConjugeAposentado();
        setTimeout(() => this.populateForms(), 100);
    }
    initForms() {
        this.correspondenciaForm = this.fb.group({
            enderecoCorrespondencia: ['', Validators.required]
        });
        this.enderecosForm = this.fb.group({});
        this.enderecosForm.addControl('enderecoCorrespondencia', this.correspondenciaForm);
    }
    populateForms() {
        if (this.proposta.cliente.enderecos) {
            const enderecos = this.proposta.cliente.enderecos;
            const residencialForm = enderecos.filter(e => e.tipoEndereco === 'RESIDENCIAL')[0] || {};
            const comercialForm = enderecos.filter(e => e.tipoEndereco === 'COMERCIAL')[0] || {};
            const enderecoCorrespondencia = enderecos.filter(e => e.correspondencia).map(e => e.tipoEndereco)[0];
            console.log('enderecos iniciados:', enderecos, enderecoCorrespondencia);
            this.enderecosForm.patchValue({
                residencialForm,
                comercialForm,
            }, { emitEvent: false });
            if (enderecoCorrespondencia) {
                this.correspondenciaForm.patchValue({ enderecoCorrespondencia });
            }
        }
    }
    onClickNext() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.showLoader = true;
            this.setEnderecos();
            EcommerceEtapas.proposta = this.proposta;
            yield this.cdcLojaService.salvarProposta(this.proposta).toPromise();
            this.showLoader = false;
            this.next.emit();
        });
    }
    onClickPrevious() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.showLoader = true;
            this.setEnderecos();
            EcommerceEtapas.proposta = this.proposta;
            this.showLoader = false;
            this.previous.emit();
        });
    }
    setEnderecos() {
        const enderecoResidencial = this.enderecoResidencialForm.getRawValue();
        const enderecoComercial = this.hasEnderecoComercial
            ? this.enderecoComercialForm.getRawValue()
            : this.copyEnderecoResidencialToComercial(enderecoResidencial);
        this.proposta.cliente.enderecos = [];
        enderecoComercial.cep = (enderecoComercial.cep || '').replace('-', '');
        enderecoComercial.correspondencia = this.isEnderecoComercialCorrespondencia();
        this.proposta.cliente.enderecos.push(enderecoComercial);
        enderecoResidencial.cep = (enderecoResidencial.cep || '').replace('-', '');
        enderecoResidencial.correspondencia = this.isEnderecoResidencialCorrespondencia();
        this.proposta.cliente.enderecos.push(enderecoResidencial);
    }
    copyEnderecoResidencialToComercial(enderecoResidencial) {
        const enderecoComercial = Object.assign({}, enderecoResidencial);
        enderecoComercial.tipoEndereco = 'COMERCIAL';
        return enderecoComercial;
    }
    isEnderecoResidencialCorrespondencia() {
        return this.enderecoCorrespondencia.value === 'RESIDENCIAL';
    }
    isEnderecoComercialCorrespondencia() {
        return this.enderecoCorrespondencia.value === 'COMERCIAL';
    }
    isAposentadoOrAutonomo() {
        return [5, 7].includes(this.classeProfissional);
    }
    isConjugeAposentado() {
        return this.proposta.conjuge && this.proposta.conjuge.dadosProfissionais &&
            [5, 7].includes(this.proposta.conjuge.dadosProfissionais.classeProfissional.id);
    }
    get enderecoCorrespondencia() {
        return this.correspondenciaForm.get('enderecoCorrespondencia');
    }
    get enderecoResidencialForm() {
        return this.enderecosForm.get('residencialForm');
    }
    get enderecoComercialForm() {
        return this.enderecosForm.get('comercialForm');
    }
    get classeProfissional() {
        return this.proposta.cliente.dadosProfissionais.classeProfissional.id;
    }
}
